import React from "react";
import { Phone, MessageCircle } from "lucide-react";

export default function StickyMobileBar() {
  return (
    <div className="sticky-mobile" data-testid="sticky-mobile">
      <a href="tel:+917666753201" className="flex-1 py-4 flex items-center justify-center gap-2 text-white font-btn text-xs border-r border-white/10" data-testid="sticky-call">
        <Phone size={14}/> Call
      </a>
      <a href="https://wa.me/917666753201" target="_blank" rel="noreferrer" className="flex-1 py-4 flex items-center justify-center gap-2 text-[#C8A45D] font-btn text-xs" data-testid="sticky-whatsapp">
        <MessageCircle size={14}/> WhatsApp
      </a>
    </div>
  );
}
